var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint0_linear_14823_29501)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.1209 12.1209C12.1209 11.5391 12.5088 11.1512 13.0906 11.1512H19.8785V7.27243C19.8785 6.69061 19.4906 6.30273 18.9088 6.30273H7.27243C6.69061 6.30273 6.30273 6.69061 6.30273 7.27243V16.9694C6.30273 17.5512 6.69061 17.9391 7.27243 17.9391H9.21182V19.9755C9.21182 20.6542 9.98757 20.9452 10.4724 20.4603L12.1209 18.8118V12.1209Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6968 12.1204V21.8173C25.6968 22.3991 25.309 22.787 24.7272 22.787H22.7878V24.8234C22.7878 25.5022 22.012 25.7931 21.5272 25.3082L18.909 22.6901H13.0908C12.509 22.6901 12.1211 22.3022 12.1211 21.7204V12.0234C12.1211 11.4416 12.509 11.0537 13.0908 11.0537H24.7272C25.309 11.1507 25.6968 11.5385 25.6968 12.1204ZM22.7878 15.0294C22.7878 14.4476 22.3999 14.0598 21.8181 14.0598H15.9999C15.4181 14.0598 15.0302 14.4476 15.0302 15.0294C15.0302 15.6113 15.4181 15.9991 15.9999 15.9991H21.8181C22.3999 15.9991 22.7878 15.6113 22.7878 15.0294ZM20.8484 18.9082C20.8484 18.3264 20.4605 17.9385 19.8787 17.9385H15.9999C15.4181 17.9385 15.0302 18.3264 15.0302 18.9082C15.0302 19.4901 15.4181 19.8779 15.9999 19.8779H19.8787C20.4605 19.8779 20.8484 19.4901 20.8484 18.9082Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14823_29501",
    x1: 32,
    y1: 9.31104,
    x2: -1.61938,
    y2: 13.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22356C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212641"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErp);
export default __webpack_public_path__ + "static/media/ERP.5067b9ab9b8c9f1266390c624d65f6ed.svg";
export { ForwardRef as ReactComponent };